import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Avatar,
  Box,
  Grid,
  Paper,
  Stack,
  Tab,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import ListadoCardJuegos from '../../juegos/components/ListadoCardJuegos';
import { allJugadoresAction } from '../../jugadores/JugadoresAction';
import { PARAMS_JUGADORES } from '../../jugadores/JugadoresReducer';
import JugadoresView from '../../jugadores/JugadoresView';
import FormEquipos from '../components/FormEquipos';

const PanelTorneosView = () => {
  const dispatch = Redux.useDispatch();

  const equiposStore = Redux.useSelector((state) => state.equipos);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const jugadoresStore = Redux.useSelector((state) => state.jugadores);

  const activo = equiposStore.activo;

  const [tab, setValue] = React.useState('1');
  const [openModalForm, setOpenModalForm] = React.useState(false);

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...jugadoresStore.params,
        idTorneo: torneosStore.activo?.id,
        idEquipo: equiposStore.activo?.id,
      };
      dispatch({ type: PARAMS_JUGADORES, payload });

      if (
        (jugadoresStore.all && jugadoresStore.all.length === 0) ||
        equiposStore.activo.id !== jugadoresStore.params.idEquipo
      ) {
        await allJugadoresAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={equiposStore.loadingAll}
          text={'Cargando datos...'}
        />
      </Grid>
      <Grid item md={4}>
        <Stack direction="column" spacing={1}>
          <Paper elevation={4} sx={{ px: 1 }}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={12} align="center">
                <Avatar
                  alt={activo.imagen?.pnombre}
                  sx={{ width: 150, height: 150, my: 2 }}
                  src={getFilesArchivos(activo.imagen)}
                />
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <Typography variant="h6">{activo.nombre}</Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <strong>Entrenador: </strong>
                <Stack direction="row" alignItems="center">
                  <Avatar
                    alt={activo.entrenador.perfil.avatar?.nombre}
                    sx={{ width: 60, height: 60, mr: 1 }}
                    src={getFilesArchivos(activo.entrenador.perfil.avatar)}
                  />
                  <Typography variant="body1">
                    {activo.entrenador.perfil.pnombre.toUpperCase()}{' '}
                    {activo.entrenador.perfil.papellido.toUpperCase()}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <strong>Líder: </strong>
                <Stack direction="row" alignItems="center">
                  <Avatar
                    alt={activo.lider?.jugador.perfil.avatar?.nombre}
                    sx={{ width: 60, height: 60, mr: 1 }}
                    src={getFilesArchivos(activo.lider?.jugador.perfil.avatar)}
                  />
                  <Typography variant="body1">
                    {activo.lider?.jugador.perfil.pnombre.toUpperCase()}{' '}
                    {activo.lider?.jugador.perfil.papellido.toUpperCase()}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <BotonComponent
                  click={() => {
                    setOpenModalForm(true);
                  }}
                  blue
                  text="EDITAR"
                  editIcon
                  mb={2}
                />
              </Grid>
            </Grid>
          </Paper>
        </Stack>
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Juegos" value="1" />
                <Tab label="Jugadores" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0 }}>
              <ListadoCardJuegos idEquipo={activo.id} />
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}>
              <JugadoresView showColumnEquipo={false} />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>

      <ModalComponent
        id="modalFormEquipos"
        title={`${
          equiposStore.activo
            ? `Editar ${equiposStore.activo.nombre}`
            : 'Nuevo equipo'
        }`}
        maxWidth="lg"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEquipos
          isPanel
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default PanelTorneosView;
